import React, { useState, useEffect } from "react";
import "./AllTypeloan.css";
import MyImage from "../images/nn.webp"; 
import as18 from "../images/as (18).svg";
import as17 from "../images/as (17).svg";
import as16 from "../images/as (16).svg";
import as15 from "../images/as (15).svg";
import as14 from "../images/as (14).svg";
import as13 from "../images/as (13).svg";
import as12 from "../images/mh (3).svg";
import as11 from "../images/mh (2).svg";
import as10 from "../images/mh (1).svg";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Explore from "./Explore";

function AllTypeloan() {
  const [activeIndex, setActiveIndex] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const loanTypes = [
    {
      image: as18,
      title: "Personal Loan",
      description:
        "For life’s surprises—planned or unplanned. Get quick funds without jumping through hoops.",
        button: "Apply Now",
        link: "/Individualservice",
    },
    {
      image: as17,
      title: "Home Loan",
      description:
        "Buying a home should be a dream, not a hassle. Get approved easily and move in stress-free.",
        button: "Apply Now",
        link: "/homeloan",
    },
    {
      image: as16,
      title: "Car Loan",
      description:
        "Speed up your journey with flexible loan options for cars, bikes, and everything in between.",
        button: "Apply Now",
        link: "/carloan",
    },
    {
      image: as15,
      title: "Bike Loan",
      description:
        "Your dream ride, minus the hassle. Easy two-wheeler loans, stress-free approvals.",
        button: "Apply Now",
        link: "/bikeloan",
    },
    {
      image: as14,
      title: "Education Loan",
      description:
        "The best investment? Knowledge. Fund your education without a second thought.",
        button: "Apply Now",
        link: "/educationloan",
    },
    {
      image: as13,
      title: "Business Loan",
      description:
        "A great idea needs great backing. Power your growth with funds that understand your ambition.",
        button: "Apply Now",
        link: "/businessloan",
    },
    {
      image: as11,
      title: "Gold Loan",
      description: "Unlock the power of your assets without selling them.",
      button: "Apply Now",
      link: "/gold",
    },
    {
      image: as12,
      title: "Property Loan",
      description: "Your real estate, your financial advantage.",
      button: "Apply Now",
      link: "/property",
    },
    {
      image: as10,
      title: "Medical Loan",
      description:
        "When health emergencies strike, money shouldn’t be a worry. about this loan type.",
        button: "Apply Now",
        link: "/medical",
    },
  ];


  return (
    <>
      <Navbar />

      <div
        className="main-box-6
    "
      >
        <div className="row ">
          <div className="col-12 col-md-12">
            <section className="Loan-type-center">
              <div className="container">
                <div className="row justify-content-center align-items-center text-center  py-md-4">
                  <div className="col-12">
                    <div className="main-5">
                      <div className="container p-0">
                        <div className="row align-items-center">
                          <div className="col-12 col-md-5 text-center text-md-start mb-4 mb-md-0 px-3 px-md-4">
                          <h1
                              className="fw-semibold  fs-md-2 fs-lg-1 heading-titles-1 "
                              style={{ color: "#4B4B4B" }}
                            >
                              Because Every{" "}
                              <br className="d-none d-md-block" />
                              Dream Deserves 
                               <br className="d-none d-md-block" />
                               the Right Funding!
                            </h1>
                          </div>

                          <div className="col-12 col-md-7">
                            <div className="position-relative overflow-hidden d-flex justify-content-center">
                              <div className="about-class-box-1 position-absolute"></div>

                              <div
                                className="position-relative"
                                style={{ zIndex: 1 }}
                              >
                                <img
                                  src={MyImage}
                                  alt="Hero Illustration"
                                  className="img-fluid image-class-1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="loan-type-service py-5">
              <div className="main-box mx-auto" style={{maxWidth:'1000px'}}>
              <div className="container">
                <div className="text-center mb-4">
                  <h2
                    className=" fw-semibold"
                  >
                    Types of Loans We Offer
                  </h2>
                  <p className="text-muted">Explore now</p>
                </div>

                <div className="row g-4">
                  {loanTypes.map((loan, index) => (
                    <div key={index} className="col-12 col-md-4">
                      <div
                        className="card p-4 w-55 h-100 text-center  transition-all duration-300 rounded-lg bg-white"
                        style={{
                          // border: "none",
                          boxShadow: "0px 50px 50px 0px #0000000A",
                        }}
                      >
                        <img
                          src={loan.image}
                          alt={loan.title}
                          className="img-fluid mb-3 mx-auto"
                          style={{ height: "50px", width:"50px", objectFit: "contain" }}
                        />
                        <h5 className="fw-semibold">{loan.title}</h5>
                        <p className="text-muted">{loan.description}</p>
                        <div className="d-flex justify-content-center my-3">
                          {/* <Link
                            to="/modal"
                            className="btn text-primary   fw-semibold d-flex justify-content-center align-items-center w-100 px-2 px-md-4 py-1 py-md-2 rounded-4 border-0 "
                            style={{
                              fontFamily:"poppins",
                              textDecoration: "none",
                            }}
                          >
                            Apply Now
                            <i
                              className="fas fa-arrow-right ms-2 ms-md-3 text-primary"
                              style={{fontSize: "1rem" }}
                            ></i>
                          </Link> */}



                          <Link to={loan.link} className ="text-decoration-none">
                                <button  className="btn btn-outline-white d-flex align-items-center  justify-content-center mx-auto" style={{
                                                      borderRadius: "50px",
                                                      padding: "8px 20px",
                                                      width: "fit-content",
                                                      minWidth: "140px",
                                                      marginTop: "10px",
                                                      textDecoration: "none",
                                                      fontFamily:"poppins",
                                                      fontWeight: "700",
                                                      color: "#0F62FE",
                                                    
                                                    }}
                                >{loan.button} 
                                                    <i
                                                      className="fas fa-arrow-right ms-2"
                                                      aria-hidden="true"
                                                    ></i></button>
                              </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Explore/>
      <Footer />
    </>
  );
}

export default AllTypeloan;
